import "glightbox/dist/css/glightbox.css";
import "drift-zoom/dist/drift-basic.css";

import GLightbox from "glightbox";
import Drift from "drift-zoom";

document.addEventListener("DOMContentLoaded", () => {
  // Lightbox for any gallery image links.
  if (document.querySelector(".glightbox")) {
    GLightbox({
      selector: ".glightbox",
      touchNavigation: true,
      loop: true,
      // Enlarge + zoom inside the lightbox (scroll / pinch / double-click).
      zoomable: true,
      autoplayVideos: true,
    });
  }

  // Product thumbnail zoom with an external pane.
  const thumbnails = document.querySelectorAll(".product-thumbnail");
  const paneContainer = document.querySelector(".zoom-pane-output");

  if (thumbnails.length > 0 && paneContainer) {
    thumbnails.forEach((thumbnail) => {
      new Drift(thumbnail, {
        paneContainer: paneContainer,
        inlinePane: 768,
        zoomFactor: 3,
      });
    });
  }

  // Hover-to-zoom on the main gallery images (skip video slides). Inline pane =
  // overlays the image itself, so no separate zoom container markup is needed.
  document
    .querySelectorAll("img.motorola-gallery__media[data-zoom]")
    .forEach((image) => {
      new Drift(image, {
        zoomFactor: 3,
        inlinePane: true,
        // Bounding box renders as a dark square in the middle of the loupe; off.
        hoverBoundingBox: false,
        // Do NOT contain: on smaller images a contained loupe can't fit and
        // silently fails to show. Letting it overflow keeps zoom working for all.
        containInline: false,
      });
    });
});
